var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manifest-filters-container" },
    [
      _c(
        "md-datepicker",
        {
          staticClass: "filter-date-picker",
          attrs: { "md-immediately": "", "md-debounce": 100 },
          model: {
            value: _vm.fromDate,
            callback: function ($$v) {
              _vm.fromDate = $$v
            },
            expression: "fromDate",
          },
        },
        [_c("label", [_vm._v("From Date")])]
      ),
      _c(
        "md-datepicker",
        {
          staticClass: "filter-date-picker",
          attrs: { "md-immediately": "", "md-debounce": 100 },
          model: {
            value: _vm.toDate,
            callback: function ($$v) {
              _vm.toDate = $$v
            },
            expression: "toDate",
          },
        },
        [_c("label", [_vm._v("To Date")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }